module.exports = __webpack_public_path__ + "fonts/nunito-sans-v11-latin-300.dfbeaabc.eot";